<template>
    <div class="modal_size notice_size">
        <a href="javascript:" class="ui_close" type="button" @click="closePopup">
            <span class="sr_only">popup close</span>
        </a>

        <dl class="modal_content">
            <dt class="notice ellipsis">
                <i>IT VOC</i>
            </dt>
            <dd>
                <dl class="notice_view">
                    <dt>Please contact Help Desk in case of any issue.</dt>
                    <dd>
                        SKP Helpdesk (<a href="mailto:skp.sec@samsung.com" target="_blank">skp.sec@samsung.com</a>) : 24Hr help desk [8/4(Tue) ~ 8/8(Sat) 08:00]<br>
                        Seunghyun(Chris) You (<a href="mailto:sh77.you@samsung.com" target="_blank">sh77.you@samsung.com</a>)<br>
                        Ray Myongsoek Shin (<a href="mailto:ray.shin@samsung.com" target="_blank">ray.shin@samsung.com</a>)<br>
                    </dd>
                </dl>

                <div class="today_wrap" v-if="mode === 'alert'">
                    <!-- <label class="checkbox-wrap">
                        <input type="checkbox" class="notice_chk" name="notice_chk" v-model="doNotDisplayToday" value />
                        <i class="check-icon"></i>
                        <em>{{$t('LABEL.NOTICE.DONTSHOWTODAY')}}</em>
                    </label> -->
                    <div class="item_right">
                        <a href="javascript:" class="txt_link" @click="closePopup()">
                            {{ $t('FIELD.GLOBAL.ETC.083') }}
                        </a>
                    </div>
                </div>
            </dd>
        </dl>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import axios from 'axios';
import qs from 'query-string';

import store from '@/vuex/store';
import constants from '@/constants';
import { SDLUtil, MenuUtil } from '@/utils';

export default {
    name: 'it-voc-view-popup',
    components: {
    },

    props: {
        // seq: {
        //     type: String,
        //     required: true,
        // },
        // mode: {
        //     type: String,
        //     default: 'view',
        // },
    },
    data() {
        return {
            // view: {
            //     title: '',
            //     description: '',
            // },
            // doNotDisplayToday: false,

            // fileList: [],
            // encToken: '',
        };
    },
    created() {
        // this.init();
    },
    mounted() {},
    methods: {
        // async init() {
        //     // const data = await this.fetchData();
        //     // this.setData(data);
        //     // this.setUserList(data.userLevelList, );
        // },

        closePopup() {
            if (this.doNotDisplayToday) {
                // const cookieName = 'dnd-notice-popup-'+this.seq +'-'+ moment().format("YYYYMMDD")
                SDLUtil.setNoticeRead(this.seq);
            }
            this.$emit('close');
        },
    },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/main/ITVocViewPopup.vue